import Footer from "../Homepages/Footer";
import {BsArrowLeft, BsPlusCircleFill} from 'react-icons/bs';
import { useNavigate } from "react-router-dom";
import {useSelector} from "react-redux";
import { setBlessing } from "../../reducers/userReducer";
import Blessedness from "./Blessedness";

export default function Gratitude() {
  const color = ['#B1E0FF', '#FFB1B1', '#E7F3FC', '#FDF4E4'];
  let keyId = 1;
  let count = 0;
  const incr = ()=>{
    let colors = color[count];
    count++;
    if (count === color.length) {
      count = 0;
    }
    return colors;
  }
  const navigate = useNavigate();
  const blessing = useSelector(setBlessing);
  return (
    <div className="container px-4 px-md-5 position-relative">
      <div className="heading mb-3 mt-5">
        <BsArrowLeft 
          size='30px' style={{cursor:"pointer"}}
          onClick={()=>{navigate('/newGrat')}}
        />
        <h3 className="text-center no-wrap">Count my blessings</h3>
      </div>
      <div className="mb-4">
        <h2 style={{fontWeight:"bold"}}>What are you thankful for?</h2>
      </div>
      {blessing.map((bless)=>(
        <Blessedness bless={bless} incr={incr()} key={keyId++}/>
      ))}
      <BsPlusCircleFill color="#F39237" size="40px" 
        className="arro"
        style={{cursor:"pointer"}}
        onClick={()=>{navigate('/newGrat')}}/>
      <Footer />
    </div>
  );
}
